import React, {FC, useCallback} from 'react';
import styled from 'styled-components';
import saga from '../../Tasks/saga';
import reducer from '../../Tasks/reducer';
import { useDispatch, useSelector } from 'react-redux';

// Import Styles
import ButtonsCenterInline from '../../../components/PageComponents/ButtonsCenterInline';
import H2 from '../../../components/Headings/H2';
import P from '../../../components/Paragraph';
import Button from '../../../components/ButtonsStyle/index';

// Modal Components
import {Modal} from '../../../components/Modal';
import ModalContainer from '../../../components/Modal/ModalContainer';
import ModalClose from '../../../components/Modal/ModalClose';
import ModalBody from '../../../components/Modal/ModalBody';

// Import Messages and Other Formated stuff
import { FormattedMessage } from 'react-intl';
import generalMessages from '../../generalMessages';

// Import Action
import { approveEntity } from '../actions';
import { REDUX_SAGA_KEYS, STATUSES } from '../../../config/config';
import { makeSelectLoadingButton } from '../selectors';
import {LoadFadingCircleButton} from '../../../components/Animations';
import { useInjectSagaAndReducer } from '../../../utils/helpers';
interface SuccessModal {
    closeModal: any;
    unique_id: string;
    isOpen: any;
    model: string;
    taskId: string;
}

const ApproveHrModal:FC<SuccessModal> = ({closeModal, unique_id, isOpen, model, taskId}) => {

    useInjectSagaAndReducer(REDUX_SAGA_KEYS.tasks, reducer, saga);

    const dispatch = useDispatch();

    const loadingButton = useSelector(makeSelectLoadingButton)

    const closeOnClick = useCallback(() => {
        closeModal(false);
    }, [closeModal]);

    const aproveJob = useCallback(() => {
        if(unique_id) {
            let data = {
                approved: 1,
                status: STATUSES.completed,
                task_id: taskId
            }
            dispatch(approveEntity(unique_id, data, model));
        }
    }, [dispatch, model, unique_id, taskId])

    return (
        <Modal className={isOpen ? 'modalOpen' : ''}>
            <ModalContainer>
            <ModalClose onClick={closeOnClick}><svg className="isvg"><use xlinkHref={`#close`} /></svg></ModalClose>
              <ModalBody>
                  <H2><FormattedMessage {...generalMessages.AreYouSure} /></H2>
                  <P><FormattedMessage {...generalMessages.ApproveText} /></P>
                  <ButtonsCenter>
                    <Button onClick={closeOnClick}><FormattedMessage {...generalMessages.Close} /></Button>
                    <Button disabled={loadingButton ? true : false} onClick={() => aproveJob()}>
                        <FormattedMessage {...generalMessages.Approve} />
                        {
                            loadingButton ?
                            <LoadFadingCircleButton />
                            : ''
                        }
                    </Button>
                </ButtonsCenter>
                </ModalBody>
            </ModalContainer>
        </Modal>
    )
}

const ButtonsCenter = styled(ButtonsCenterInline)`
  margin: 20px auto 0;
  max-width: 940px;

  button, a {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
`;

export default ApproveHrModal;
